import React,  { Component } from "react";
import { KeyboardDatePicker } from "@material-ui/pickers";

class AbacusDatePicker extends Component {
    constructor(props) {
        super(props);  
        this.state = {
            value: props.value,
            label: props.label,
            views: props.views,
            format: props.format
        }    
    }

    handleDateChange(date){
        this.props.onChange(date)
        this.setState({value:date});
    }

  render() {
    return (
        <KeyboardDatePicker
        //clearable
        label={this.props.label}
        value={this.props.value}
        onChange={date => this.handleDateChange(date)}
        views={this.props.views}
        //minDate={new Date()}
        format={this.props.format}
        />
    );
  }
}

export default AbacusDatePicker;